import React from 'react';

function SEOHead({
  title = "TherapyList - Find Your Perfect Therapist",
  description = "Connect with licensed therapists in your area. Find the right mental health professional for your needs with TherapyList.",
  keywords = "therapy, therapist, mental health, counseling, psychology, find therapist",
  canonical,
  ogTitle,
  ogDescription,
  ogImage = "/logo512.png",
  ogType = "website",
  twitterCard = "summary_large_image",
  noindex = false,
  additionalMeta = []
}) {
  React.useEffect(() => {
    // Update document title
    document.title = title;

    // Helper function to update or create meta tags
    const updateMetaTag = (name, content, attribute = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (element) {
        element.setAttribute('content', content);
      } else {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        element.setAttribute('content', content);
        document.head.appendChild(element);
      }
    };

    // Update basic meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    
    // Robots meta tag
    if (noindex) {
      updateMetaTag('robots', 'noindex, nofollow');
    } else {
      updateMetaTag('robots', 'index, follow');
    }

    // Open Graph tags
    updateMetaTag('og:title', ogTitle || title, 'property');
    updateMetaTag('og:description', ogDescription || description, 'property');
    updateMetaTag('og:image', ogImage, 'property');
    updateMetaTag('og:type', ogType, 'property');
    updateMetaTag('og:site_name', 'TherapyList', 'property');

    // Twitter Card tags
    updateMetaTag('twitter:card', twitterCard);
    updateMetaTag('twitter:title', ogTitle || title);
    updateMetaTag('twitter:description', ogDescription || description);
    updateMetaTag('twitter:image', ogImage);

    // Canonical URL
    if (canonical) {
      let linkElement = document.querySelector('link[rel="canonical"]');
      if (linkElement) {
        linkElement.setAttribute('href', canonical);
      } else {
        linkElement = document.createElement('link');
        linkElement.setAttribute('rel', 'canonical');
        linkElement.setAttribute('href', canonical);
        document.head.appendChild(linkElement);
      }
    }

    // Additional custom meta tags
    additionalMeta.forEach(({ name, content, property }) => {
      if (property) {
        updateMetaTag(property, content, 'property');
      } else {
        updateMetaTag(name, content);
      }
    });

  }, [title, description, keywords, canonical, ogTitle, ogDescription, ogImage, ogType, twitterCard, noindex, additionalMeta]);

  return null; // This component doesn't render anything visible
}

export default SEOHead; 